<div class='container'>
    <div class='mb-3 pt-3'>
        <div class='h3'>Sensors Usage Information</div>
        <div class='flex-grow-1 fs-2 lh-base text-center mt-5 mb-5'> <b>Fast </b>search</div>
            <div class="d-flex flex-row justify-content-center">
                <app-text-search class="flex-grow-0"
                                 [value]='serialCodeValue'
                                 [searchHint]='serialCodeHint'
                                 [maxLength]='maxLength'
                                 [minLength]='minLength'
                                 (submitEvent)='onSerialCodeAndEmailSubmit()'
                                 (valueChange)='onSerialCodeValueChange($event)'
                >
                </app-text-search>
                <app-text-search class="flex-grow-0 mx-md-1"
                                 [value]='emailValue'
                                 [searchHint]='emailHint'
                                 [maxLength]='maxLength'
                                 [minLength]='minLength'
                                 (submitEvent)='onSerialCodeAndEmailSubmit()'
                                 (valueChange)='onEmailValueChange($event)'
                >
                </app-text-search>
                <button class="flex-grow-0 m-3" color="primary" mat-raised-button type='submit'
                        [disabled]='!canEmailSerialCodeSearch()'
                        (click)="onSerialCodeAndEmailSubmit()">Search
                </button>
            </div>
            <div class="d-flex flex-row">
                <div *ngIf="showSerialCodeError()" class="fs-6 lh-base text-danger" style="margin-top: 24px;margin-bottom: 24px;">
                    Serial code field should be 5 or more characters.
                </div>
            <div *ngIf="showEmailValueError()" class="fs-6 lh-base text-danger ms-3" style="margin-top: 24px;margin-bottom: 24px;">
                The provided email does not seem to be correct<br>Please use a valid email.
            </div>
            </div>
        <div class="flex-grow-1 fs-5 lh-base" style="margin-top: 24px;margin-bottom: 24px;">
            Provide <b>email</b> and <b>serial code.</b><br>
            This is faster than below.
        </div>
        <div class='flex-grow-1 fs-2 lh-base text-center'> <b>Slow </b>search with serial codes</div>
        <div class="flex-grow-1 fs-5 lh-base" style="margin-top: 24px;margin-bottom: 24px;">
            Write <b>one</b> or <b>max 5</b> serial codes separated with commas.<br>
            This is slower than above.
        </div>
        <div class="d-flex flex-row">
        <app-text-search class="flex-grow-1"
                         [value]='serialCodesValue'
                         [searchHint]='searchSerialCodesHint'
                         [maxLength]='maxLength'
                         [minLength]='minLength'
                         (submitEvent)='onSubmit()'
                         (valueChange)='onSerialCodesValueChange($event)'
        >
        </app-text-search>
        <button class="m-3" color="primary" mat-raised-button type='submit'
                [disabled]='!canSearch()'
                (click)="onSubmit()">Search
        </button>
        </div>
    </div>
    <app-generic-admin-report-table
        [filter]='filter'
        [columnData]='columns'
        [loadingState]='loadingState'
        [dataSource]='dataSource'
        [viewModel]='viewModel'
        modelLabel='Activities'
        searchLabel='Search Sensor Usage'
    ></app-generic-admin-report-table>
</div>
